import { render, staticRenderFns } from "./ed-school-calendar.component.vue?vue&type=template&id=4276b830&scoped=true&"
import script from "./ed-school-calendar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-school-calendar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-school-calendar.component.scss?vue&type=style&index=0&id=4276b830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276b830",
  null
  
)

export default component.exports